import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import Layout from "../../components/user/Layout";
import PartnerProfile from "../../components/user/PartnerProfile";
const Profile = () => {
  const siteName = useSelector(
    (state) => state.globalState?.siteSetting?.site_settings?.site_name
  );

  return (
    <Layout>
      <Helmet>
        <title>Profile - {siteName}</title>
      </Helmet>
      <PartnerProfile />
    </Layout>
  );
};

export default Profile;
